import React from "react";
import PersonForm from "../Personnel/PersonForm";
import PersonView from "../Personnel/PersonView";
import ListScreen from "../common/ListScreen";

/* =======================================================================
 * Remaining production screens to reach full parity with App.js.
 * Built on the reusable Form / View / List components.
 * ===================================================================== */
const F = (title, fields, submit) => () => (
  <PersonForm title={title} fields={fields} submitLabel={submit || "Save"} />
);
const V = (title, name, cards) => () => <PersonView title={title} name={name} cards={cards} />;
const L = (title, search, items, addTo) => () => (
  <ListScreen title={title} search={search} items={items} addTo={addTo} />
);
const rows = (pairs) => pairs.map(([label, value, full]) => ({ label, value, full }));

const tripFields = [
  { label: "Trip Name", placeholder: "Enter Trip Name" },
  { label: "Trip Start Location", placeholder: "Enter Trip Start Location" },
  { label: "Trip End Location", placeholder: "Enter Trip End Location" },
  { label: "Trip Start Time", placeholder: "Select Start Time" },
  { label: "Trip End Time", placeholder: "Select End Time" },
  { label: "Trip Driver", placeholder: "Select Driver" },
  { label: "Trip Vehicle", placeholder: "Select Vehicle" },
];
const personFields = [
  { label: "First Name", placeholder: "Enter Your First Name" },
  { label: "Last Name", placeholder: "Enter Your Last Name" },
  { label: "Email", placeholder: "Enter Your Email" },
  { label: "Contact Number", placeholder: "Enter Your Contact Number" },
  { label: "Internal Number", placeholder: "Enter Your Internal Number" },
  { label: "Mifarecard Id", placeholder: "Enter Your Mifarecard Id" },
  { label: "Address", placeholder: "Enter Address", multiline: true },
];

// ---- Dispatch trip (new variants) ----
export const AddDispatchTripnew = F("Add Dispatch Trip", tripFields);
export const ViewDispatchTripnew = V("View Dispatch Trip", "Pune City Trip", [
  { heading: "Trip Information", rows: rows([["Driver", "John Doe"], ["Vehicle", "MH-12-5022"], ["Start", "Vishrantwadi"], ["End", "Kalas"], ["Type", "Passenger"], ["Status", "Scheduled"]]) },
]);

// ---- Vehicle Assistants (plural names in production) ----
export const EditVehicleAssistants = F("Edit Vehicle Assistant", personFields, "Update");
export const ViewVehicleAssistants = V("Vehicle Assistant Details", "Mark Woods", [
  { heading: "Personal Information", rows: rows([["Name", "Mark Woods"], ["Contact", "99999 99999"], ["Email", "markwoods@gmail.com", true], ["Internal No.", "123456"], ["Mifarecard Id", "MFC-12345"]]) },
]);

// ---- Point of Interest ----
export const EditPointOfInterest = F("Edit Point Of Interest", [
  { label: "Location Name", placeholder: "Enter Location Name..." },
  { label: "Location Address", placeholder: "Enter Location Address" },
  { label: "Type", placeholder: "Select Type" },
], "Update");

// ---- Parking ----
export const ParkingManagementone = L("Parking Management", "Search Station...", [
  { title: "Redbytes Parking", subtitle: "Test12345 • Pune", to: "EditParkingSlot" },
  { title: "City Center Parking", subtitle: "Code-9921 • Pune", to: "EditParkingSlot" },
], "EditParkingSlot");

// ---- Vehicle Expense detail views ----
export const ViewVehicleAccesory = V("Vehicle Accessory Details", "GPS Tracker", [
  { heading: "Accessory", rows: rows([["Vehicle", "MH-12-5022"], ["Accessory", "GPS Tracker"], ["Cost", "QAR 350"], ["Date", "08-10-2022"], ["Status", "Active"]]) },
]);
export const ViewVehicleAccident = V("Vehicle Accident Details", "Accident #AC-21", [
  { heading: "Accident", rows: rows([["Vehicle", "MH-12-5022"], ["Driver", "John Doe"], ["Date", "08-10-2022"], ["Location", "Vishrantwadi", true], ["Severity", "Minor"], ["Cost", "QAR 1,200"]]) },
]);
export const ViewVehicleMaintenance = V("Vehicle Maintenance Details", "Service #MN-14", [
  { heading: "Maintenance", rows: rows([["Vehicle", "MH-12-5022"], ["Type", "Periodic Service"], ["Date", "08-10-2022"], ["Garage", "AutoCare Pune", true], ["Cost", "QAR 800"], ["Status", "Completed"]]) },
]);
export const ViewVehicleSpareParts = V("Vehicle Spare Part Details", "Brake Pads", [
  { heading: "Spare Part", rows: rows([["Vehicle", "MH-12-5022"], ["Part", "Brake Pads"], ["Quantity", "2"], ["Cost", "QAR 220"], ["Date", "08-10-2022"]]) },
]);

// ---- Inspection ----
export const NewVehicleInspection = F("New Vehicle Inspection", [
  { label: "Vehicle", placeholder: "Select Vehicle" },
  { label: "Inspector", placeholder: "Select Inspector" },
  { label: "Date", placeholder: "Select Date" },
  { label: "Checklist", placeholder: "Brakes, Lights, Tyres..." },
  { label: "Remarks", placeholder: "Enter Remarks", multiline: true },
], "Submit");
export const ViewInspectionDetails = V("Inspection Details", "Inspection #INS-44", [
  { heading: "Inspection", rows: rows([["Vehicle", "MH-12-5022"], ["Inspector", "John Doe"], ["Date", "08-10-2022"], ["Result", "Passed"], ["Remarks", "All checks ok", true]]) },
]);

// ---- Payment ----
export const PaidPaymentInvoice = V("Paid Payment Invoice", "Invoice #INV-2201", [
  { heading: "Invoice", rows: rows([["Invoice No", "INV-2201"], ["Customer", "Mark Woods"], ["Amount", "QAR 250"], ["Paid On", "08-10-2022"], ["Status", "Paid"]]) },
]);
export const PaidPaymentReceipt = V("Payment Receipt", "Receipt #RC-2201", [
  { heading: "Receipt", rows: rows([["Receipt No", "RC-2201"], ["Invoice", "INV-2201"], ["Amount", "QAR 250"], ["Method", "Card"], ["Date", "08-10-2022"]]) },
]);

// ---- Fuel Management ----
export const FuelManagementDashbord = L("Fuel Management", "Search Vehicle...", [
  { title: "MH-12-5022", subtitle: "Avg 12 km/l • 40L today", to: "FuelManagementDetails" },
  { title: "MH-12-2023", subtitle: "Avg 10 km/l • 35L today", to: "FuelManagementDetails" },
]);
export const FuelManagementDetails = V("Fuel Details", "MH-12-5022", [
  { heading: "Fuel Information", rows: rows([["Vehicle", "MH-12-5022"], ["Fuel Type", "Diesel"], ["Capacity", "60 L"], ["Current", "42 L"], ["Avg Mileage", "12 km/l"], ["Last Refuel", "08-10-2022"]]) },
]);

// ---- Reports (Hardware features) ----
export const Driverbehavioureports = L("Driver Behaviour Reports", "Search Driver...", [
  { title: "John Doe", subtitle: "Harsh braking: 3 • Overspeed: 1", to: "ReportView" },
  { title: "Mark Woods", subtitle: "Harsh braking: 0 • Overspeed: 0", to: "ReportView" },
]);
export const Immobiliserreports = L("Immobiliser Reports", "Search Vehicle...", [
  { title: "MH-12-5022", subtitle: "Immobilised • 08-10-2022 22:10" },
  { title: "MH-12-2023", subtitle: "Active • —" },
]);
export const GenerateCustomReport = F("Generate Custom Report", [
  { label: "Report Type", placeholder: "Select Report Type" },
  { label: "Vehicles", placeholder: "Select Vehicles" },
  { label: "From Date", placeholder: "Select Date" },
  { label: "To Date", placeholder: "Select Date" },
  { label: "Format", placeholder: "PDF / Excel" },
], "Generate");
export const ReportDistributionContacts_Details = V("Distribution Contact Details", "Mark Woods", [
  { heading: "Contact", rows: rows([["Name", "Mark Woods"], ["Email", "markwoods@gmail.com", true], ["Contact", "99999 99999"], ["Reports", "Daily Location, Fuel", true]]) },
]);

// ---- Notification / Logo / Config ----
export const NotificationDetails = V("Notification Details", "Overspeed Alert", [
  { heading: "Notification", rows: rows([["Type", "Overspeed"], ["Vehicle", "MH-12-5022"], ["Time", "08-10-2022 10:24"], ["Message", "Vehicle crossed 80 km/h near Vishrantwadi.", true]]) },
]);
export const UpdateCustomerLogo = F("Update Customer Logo", [
  { label: "Company Logo", placeholder: "Select Logo Image" },
], "Update");
export const ConfigurationChecker = V("Configuration Checker", "System Status", [
  { heading: "Status", rows: rows([["API", "Connected"], ["GPS Feed", "Active"], ["Map", "Loaded"], ["Notifications", "Enabled"]]) },
]);

// ---- Delivery / Dispatch ----
export const DeliveryDispatchManagement = L("Delivery Dispatch Management", "Search Order...", [
  { title: "Order #1001", subtitle: "Mark Woods • In Progress", to: "ViewOrder" },
  { title: "Order #1002", subtitle: "John Doe • Delivered", to: "ViewOrder" },
], "AddDispatchCustomer");

// ---- MarketPlace / Direct Order / Auction ----
export const DirectOrderMarketPlace = L("Direct Order MarketPlace", "Search Order...", [
  { title: "Load #LD-201", subtitle: "Pune → Mumbai • Open", to: "DirectOrderVehicleDetails" },
  { title: "Load #LD-202", subtitle: "Pune → Nashik • Assigned", to: "DirectOrderVehicleDetails" },
]);
export const DirectOrderAddVehicle = F("Add Vehicle (Direct Order)", [
  { label: "Customer Name", placeholder: "Enter Customer Name..." },
  { label: "Vehicle", placeholder: "Select Vehicle" },
  { label: "Load", placeholder: "Select Load" },
  { label: "Price", placeholder: "Enter Price" },
]);
export const DirectOrderConfirmation = V("Direct Order Confirmation", "Order #DO-11", [
  { heading: "Order", rows: rows([["Order", "DO-11"], ["Vehicle", "MH-12-5022"], ["Route", "Pune → Mumbai", true], ["Price", "QAR 1,500"], ["Status", "Confirmed"]]) },
]);
export const DirectOrderOfferLoad = V("Offer Load", "Load #LD-201", [
  { heading: "Load", rows: rows([["Load", "LD-201"], ["Route", "Pune → Mumbai", true], ["Weight", "12 T"], ["Offer", "QAR 1,500"]]) },
]);
export const DirectOrderReferenceDetails = V("Reference Details", "Ref #RF-21", [
  { heading: "Reference", rows: rows([["Reference", "RF-21"], ["Order", "DO-11"], ["Verified", "Yes"]]) },
]);
export const DirectOrderVehicleDetails = V("Vehicle Details", "MH-12-5022", [
  { heading: "Vehicle", rows: rows([["Vehicle", "MH-12-5022"], ["Driver", "John Doe"], ["Capacity", "12 T"], ["Type", "Truck"]]) },
]);
export const OfferDriverMarketPlace = V("Driver Offer", "John Doe", [
  { heading: "Offer", rows: rows([["Driver", "John Doe"], ["Load", "LD-201"], ["Offer", "QAR 1,500"], ["Status", "Pending"]]) },
]);
export const OfferVehicleMarketPlace = V("Vehicle Offer", "MH-12-5022", [
  { heading: "Offer", rows: rows([["Vehicle", "MH-12-5022"], ["Load", "LD-201"], ["Offer", "QAR 1,500"], ["Status", "Pending"]]) },
]);
export const OnlineAuctionMarketPlace = L("Online Auction MarketPlace", "Search Auction...", [
  { title: "Toyota Innova - 2021", subtitle: "Current Bid: QAR 45,000", to: "OnlineAuctionVehicleDetails" },
  { title: "Honda City - 2020", subtitle: "Current Bid: QAR 32,000", to: "OnlineAuctionVehicleDetails" },
]);
export const OnlineAuctionVehicleDetails = V("Auction Vehicle Details", "Toyota Innova - 2021", [
  { heading: "Vehicle", rows: rows([["Vehicle", "Toyota Innova"], ["Year", "2021"], ["Base Price", "QAR 40,000"], ["Current Bid", "QAR 45,000"], ["Bidders", "8"]]) },
]);
